module.exports = __webpack_public_path__ + "static/media/Spotify_Logo_CMYK_Green.321247fa.png";